import React, { useState, useEffect, useRef } from "react";
import ChecklistItem from "./ChecklistItem";
import { sortableContainer, sortableElement } from "react-sortable-hoc";
import store from "glassRedux/store";

import {
  addChecklistItem,
  moveChecklistItem,
  removeChecklistItem,
} from "shared/checklists/redux/checklistSlice";

const SortableItem = sortableElement((props) => <ChecklistItem {...props} />);

const SortableContainer = sortableContainer(({ children }) => {
  return <ul>{children}</ul>;
});

export default function ChecklistItems(props) {
  const { undoneIds, entities, itemId } = props;

  const [inputRefs, setInputRefs] = useState([]);

  useEffect(() => {
    window.addEventListener("keydown", onChecklistItemsKeyDown);
    return function cleanup() {
      window.removeEventListener("keydown", onChecklistItemsKeyDown);
    };
  }, []);

  function onSortEnd({ oldIndex, newIndex }) {
    if (oldIndex !== newIndex) {
      const id = undoneIds[oldIndex];
      store.dispatch(moveChecklistItem({ oldIndex, newIndex, id }));
    }
  }

  function onChecklistItemsKeyDown(event) {
    if (
      document.activeElement.className !== "checklist-item-name" &&
      event.key === "Enter"
    ) {
      store.dispatch(addChecklistItem({ index: "end" }));
    } else {
      if (event.key === "ArrowUp" || event.key === "ArrowDown") {
        event.preventDefault();
        moveCursorUpOrDown(event.key);
      }
    }
  }

  function moveCursorUpOrDown(keydown) {
    const index = Number.parseInt(
      document.activeElement.parentElement.dataset.index
    );
    const incrementor = { ArrowUp: -1, ArrowDown: 1 }[keydown];
    const newIndex = index + incrementor;
    if (inputRefs[newIndex] && inputRefs[newIndex].current) {
      const position = {
        ArrowUp: { rightOffset: 0 },
        ArrowDown: { leftOffset: 0 },
      }[keydown];

      setCursorPosition({ element: inputRefs[newIndex].current, ...position });
    }
  }

  function setCursorPosition({ element, rightOffset, leftOffset }) {
    console.log(element.innerHTML, leftOffset, rightOffset);
    if (element.innerHTML !== "") {
      if (!leftOffset) {
        leftOffset = element.innerHTML.length - rightOffset;
      }
      const range = document.createRange();
      const sel = window.getSelection();
      range.setStart(element.childNodes[0], leftOffset);
      range.collapse(true);
      sel.removeAllRanges();
      sel.addRange(range);
    }
    element.focus();
  }

  return (
    <SortableContainer
      onSortEnd={onSortEnd}
      helperClass="is-dragging"
      lockAxis="y"
      pressDelay={400}
      shouldCancelStart={() => {
        return false;
      }}
      lockToContainerEdges={true}
    >
      {undoneIds.map((id, i) => {
        const item = entities[id];
        return (
          <SortableItem
            key={item.id}
            hasBreak={i > 0}
            index={i}
            ciIndex={i}
            {...{ itemId, setCursorPosition, inputRefs }}
            {...item}
          />
        );
      })}
    </SortableContainer>
  );
}
